module.exports = __webpack_public_path__ + "img/prozessorientiertes-denken.90701ed9.png";